<template>
  <div class="body-wrapper">
    <QuestionImage
        :attaches="questionData?.content?.attach
    ?.filter(item => item.file?.attachUrl)
    ?.map(item => ({ attachUrl: item.file.attachUrl })) || []"
    />
    <div class="sentence-container">
      <template  v-for="word in wordArray">
        <span class="word-text" v-if="!word?.isBlank">{{ word.text }}</span>
        <div class="blank-space" v-else>
          <span>______</span>
        </div>
      </template>
    </div>

    <div class="draggable-words-container">
      <template  v-for="(word, index) in randomAnswerWords" :key="index" >
        <div class="draggable-word" >
          <span>{{ word }}</span>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import QuestionImage from "@/components/QuestionImage.vue";

export default{
  components: {QuestionImage},
  props:{
    questionData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      wordArray: [],
      randomAnswerWords: [],
    };
  },
  created(){
    const blankOutWords = this.questionData?.content?.blankOutWords || [];
    const otherWords = this.questionData?.content?.otherWords || [];


    this.wordArray = this.questionData?.name?.split(' ').map((word, index) => ({
      id: `word-${index}`,
      text: word,
      isBlank: blankOutWords.includes(index.toString()),
      index: index,
    }));


    if (blankOutWords.length === 0 && otherWords.length === 0) {
      this.randomAnswerWords = [];
      return;
    }

    this.wordArray.map((word, index) => {
      if (word.isBlank) {
        this.randomAnswerWords.push(word?.text);
      }
    });

    this.randomAnswerWords.push(otherWords);

    this.randomAnswerWords = this.randomAnswerWords
      .flat()
      .filter((word) => word && word.trim() !== '')
      .sort(() => Math.random() - 0.5);
  }
}
</script>

<style scoped>
.body-wrapper {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  padding: 10px;
  z-index: 1;
}

.title {
  font-size: 18px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_semi_bold, sans-serif;
}

.sentence-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.word-text {
  font-size: 16px;
  color: #040C2D;
  font-family: euclid_regular, sans-serif;
}

.blank-space {
  min-width: 80px;
  height: 36px;
  background-color: #F2F4F7;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  border: 1px solid #D0D5DD;
  padding: 4px 0;

}

.blank-space span {
  font-size: 16px;
  color: #475467;
  font-family: euclid_medium, sans-serif;
  text-align: center;
}

.draggable-words-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 30px;
}

.draggable-word {
  display: flex;
  padding: 5px;
  background-color: #EBEDFB;
  border-radius: 8px;
  min-width: 60px;
  justify-content: center;
  align-items: center;
}

.draggable-word span {
  font-size: 14px;
  color: #040C2D;
  font-family: euclid_regular, sans-serif;
}

</style>
